import { AxiosPromise } from 'axios';
import { SERVICE_ID, INTERNAL_PHONENUMBERS, URLS } from '@/services/Constants';
import { commonAxios as axios } from '@/services/Authentication';

export default {
    // GET

    /**
     * Return all groups
     *
     * @returns {AxiosPromise<any>}
     */
    getAllGroups(): AxiosPromise<any> {
        return axios().request({
            url: URLS().urlGroups,
            method: 'get'
        });
    },

    /**
     * Return Group by Id
     *
     * @param {string} groupId
     * @returns {AxiosPromise<any>}
     */
    getGroupById(groupId: string): AxiosPromise<any> {
        return axios().request({
            url: URLS().urlGroups + '/' + groupId,
            method: 'get'
        });
    },

    // POST

    /**
     * Create new group
     *
     * @param {*} data
     * @returns {AxiosPromise<any>}
     */
    createGroup(data: any): AxiosPromise<any> {
        return axios().request({
            url: URLS().urlGroups,
            method: 'post',
            data
        });
    },

    // PUT

    /**
     * Update group according to provided data
     *
     * @param {*} data
     * @returns {AxiosPromise<any>}
     */
    updateGroup(data: any): AxiosPromise<any> {
        return axios().request({
            url: URLS().urlGroups,
            method: 'put',
            data
        });
    },

    // DELETE

    /**
     * Remove group by Id
     *
     * @param {string} groupId
     * @returns {AxiosPromise<any>}
     */
    deleteGroup(groupId: string): AxiosPromise<any> {
        return axios().request({
            url: URLS().urlGroups + '/' + groupId,
            method: 'delete'
        });
    },

    // POSTPROCESSING

    findGroupByGroupId(groups: any[], groupId: string): any {
        return groups.find(group => group.groupId === groupId);
    },

    findGroupByGroupName(groups: any[], groupName: string): any {
        return groups.find(group => group.groupname === groupName);
    }
};
